// Orchestration services & resources — sample libraries, scoring services,
// orchestrators, contractors, and education for composers writing for orchestra.
export const ORCHESTRATION_RESOURCES = [
  // Scoring / orchestration services
  { name: "Spitfire Audio", website: "https://www.spitfireaudio.com", domain: "spitfireaudio.com",
    category: "Sample Library" },
  { name: "Vienna Symphonic Library", website: "https://www.vsl.co.at", domain: "vsl.co.at",
    category: "Sample Library" },
  { name: "EastWest Sounds", website: "https://www.soundsonline.com", domain: "soundsonline.com",
    category: "Sample Library" },
  { name: "Cinesamples", website: "https://cinesamples.com", domain: "cinesamples.com",
    category: "Sample Library" },
  { name: "Orchestral Tools", website: "https://www.orchestraltools.com", domain: "orchestraltools.com",
    category: "Sample Library" },
  { name: "Native Instruments", website: "https://www.native-instruments.com", domain: "native-instruments.com",
    category: "Sample Library" },
  { name: "8Dio", website: "https://8dio.com", domain: "8dio.com",
    category: "Sample Library" },

  // Notation / scoring software
  { name: "Sibelius (Avid)", website: "https://www.avid.com/sibelius", domain: "avid.com",
    category: "Notation Software" },
  { name: "Dorico (Steinberg)", website: "https://www.steinberg.net/dorico", domain: "steinberg.net",
    category: "Notation Software" },
  { name: "Finale", website: "https://www.finalemusic.com", domain: "finalemusic.com",
    category: "Notation Software" },
  { name: "MuseScore", website: "https://musescore.org", domain: "musescore.org",
    category: "Notation Software" },

  // Orchestras / contractors
  { name: "Los Angeles Philharmonic", website: "https://www.laphil.com", domain: "laphil.com",
    category: "Orchestra · Live" },
  { name: "New York Philharmonic", website: "https://nyphil.org", domain: "nyphil.org",
    category: "Orchestra · Live" },
  { name: "London Symphony Orchestra", website: "https://lso.co.uk", domain: "lso.co.uk",
    category: "Orchestra · Live" },
  { name: "Macedonian Radio Symphonic Orchestra", website: "https://www.macedonian-rso.com", domain: "macedonian-rso.com",
    category: "Orchestra · Recording" },
  { name: "Budapest Scoring Orchestra", website: "https://www.budapestscoring.com", domain: "budapestscoring.com",
    category: "Orchestra · Recording" },
  { name: "Nashville Scoring Orchestra", website: "https://nashvillescoring.com", domain: "nashvillescoring.com",
    category: "Orchestra · Recording" },

  // Trade orgs / education / arrangers
  { name: "League of American Orchestras", website: "https://americanorchestras.org", domain: "americanorchestras.org",
    category: "Trade Association" },
  { name: "Society of Composers & Lyricists", website: "https://thescl.com", domain: "thescl.com",
    category: "Trade Association" },
  { name: "Berklee College of Music", website: "https://www.berklee.edu", domain: "berklee.edu",
    category: "Education" },
  { name: "Royal College of Music (London)", website: "https://www.rcm.ac.uk", domain: "rcm.ac.uk",
    category: "Education" },
  { name: "Vienna Symphonic Library Academy", website: "https://www.vsl.co.at/en/Academy", domain: "vsl.co.at",
    category: "Education" },
];

export const ORCHESTRATION_GROUPS = [
  { key: "Sample Library", label: "Sample Libraries", overline: "Virtual orchestra · Production" },
  { key: "Notation Software", label: "Notation & Scoring Software", overline: "Engraving · Score prep" },
  { key: "Orchestra · Live", label: "Major Orchestras", overline: "Live performance · Touring" },
  { key: "Orchestra · Recording", label: "Recording Orchestras", overline: "Scoring sessions · Hire" },
  { key: "Trade Association", label: "Trade Associations", overline: "Advocacy · Membership" },
  { key: "Education", label: "Education", overline: "Conservatories · Courses" },
];
